import { i18nTranslationHelper } from '@/i18n'
import getCategoryGroupPaths from '@/main/routes/paths/category-group-paths'
import PathConstants from '../path-contants'
import getCategoriesPaths from './category-paths'
import { computeContentValueId } from './compute-path-helper'

const getContentDiscoveryPaths = (): PathConstants.RoutesProps => {
  const t = i18nTranslationHelper.getTPage
  return {
    HOME: {
      value: '/',
      name: 'home',
      title: t('home.pageTitle')
    },
    SEARCH: {
      value: '/search',
      name: 'search',
      title: 'Busca'
    },
    SKILLS: {
      value: '/skills/:id',
      name: 'skill',
      title: 'Habilidades',
      computeValue: args => `/skills/${args.id}`
    },
    INSTITUTIONS: {
      value: '/partners',
      name: 'partners',
      title: t('partners.pageTitle')
    },
    INSTITUTION: {
      value: '/partners/:id',
      name: 'partner',
      computeValue: args => `/partners/${args.id}`
    },
    CONTENT: {
      value: '/content/:id',
      name: 'content',
      computeValue: ({ content }) => `/content/${computeContentValueId(content)}`
    },
    ...getCategoriesPaths(),
    ...getCategoryGroupPaths()
  }
}

export default getContentDiscoveryPaths
